import React, {useState, useEffect} from 'react';
import {Link} from 'react-router-dom';
import useFetch from "../hooks/useFetch";

const HeroBanner = () => {
    const [currentSlide, setCurrentSlide] = useState(0);

    const {data: slides = []} = useFetch(`/products/banners`);
    const {data: cameraCategories = []} = useFetch(`/categories`);

    useEffect(() => {
        if (!slides?.length) return;

        const interval = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % slides?.length);
        }, 5000);

        return () => clearInterval(interval);
    }, [slides?.length]);

    const next = () => {
        if (!slides?.length) return;
        setCurrentSlide((prev) => (prev + 1) % slides?.length);
    };

    const prev = () => {
        if (!slides?.length) return;
        setCurrentSlide((prev) => (prev - 1 + slides?.length) % slides?.length);
    };

    return (
        <section className="bg-primary/95 -mt-1">
            <div className="container mx-auto px-4 py-6 space-y-8">

                {/* Banner slider */}
                <div className="relative rounded-3xl overflow-hidden shadow-2xl border border-white/10">
                    <div className="relative aspect-video md:aspect-[16/6] lg:aspect-[21/7]">
                        {slides?.map((slide, i) => (
                            <div
                                key={slide.id ?? i}
                                className={`absolute inset-0 transition-opacity duration-1000 ease-in-out ${
                                    currentSlide === i ? 'opacity-100' : 'opacity-0'
                                }`}
                            >
                                <img
                                    src={slide.image}
                                    alt={slide.title || 'Promo banner'}
                                    className="w-full h-full object-cover"
                                />
                            </div>
                        ))}

                        {slides?.length > 0 && (
                            <>
                                <button
                                    onClick={prev}
                                    className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/20 hover:bg-white/30 backdrop-blur-md text-white p-3 md:p-4 rounded-full transition z-10"
                                >
                                    <svg className="w-6 h-6 md:w-8 md:h-8" fill="none" stroke="currentColor"
                                         viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                              d="M15 19l-7-7 7-7"/>
                                    </svg>
                                </button>

                                <button
                                    onClick={next}
                                    className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/20 hover:bg-white/30 backdrop-blur-md text-white p-3 md:p-4 rounded-full transition z-10"
                                >
                                    <svg className="w-6 h-6 md:w-8 md:h-8" fill="none" stroke="currentColor"
                                         viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                              d="M9 5l7 7-7 7"/>
                                    </svg>
                                </button>

                                <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2 z-10">
                                    {slides?.map((_, i) => (
                                        <button
                                            key={i}
                                            onClick={() => setCurrentSlide(i)}
                                            className={`transition-all ${
                                                currentSlide === i
                                                    ? 'w-10 h-2 bg-white'
                                                    : 'w-2 h-2 bg-white/60'
                                            } rounded-full`}
                                        />
                                    ))}
                                </div>
                            </>
                        )}
                    </div>
                </div>

                {/* Kategoriyalar */}
                <div
                    className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 xl:grid-cols-10 gap-4 md:gap-6">
                    {cameraCategories?.map((cat, i) => (
                        <Link
                            key={i}
                            to={`/products/${cat?.id}`}
                            className="flex flex-col items-center gap-3 bg-white/10 hover:bg-white/20 backdrop-blur-xl rounded-2xl p-5 transition-all duration-300 hover:scale-105 shadow-lg border border-white/10 group"
                        >
                            <div
                                className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center shadow-inner group-hover:shadow-accent/40 transition">
                                <img src={cat?.image} alt={cat?.category_name} className="w-10 h-10 object-contain"/>
                            </div>
                            <span className="text-white text-xs md:text-sm font-medium text-center leading-tight">
                            {cat?.title}
                          </span>
                        </Link>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default HeroBanner;
